"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Advertisement_1 = require("./Advertisement");
exports.default = Advertisement_1.default;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/ui-components/components/containers/Advertisement/index.js
// module id = 1341
// module chunks = 8